import { useContext } from "react";
import { MedicalEncounterContext } from "../contexts/MedicalEncounterProvider";

const useMedicalEncounter = () => useContext(MedicalEncounterContext);

export default useMedicalEncounter;
